const matches = require('validator/lib/matches')

export default (values) => {
  let errors = {}

  if (values.password) {
    if (!matches(values.password, /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/)) {
      errors.password =
        'A senha deve conter mais de 8 caracteres entre letras e números!'
    }

    if (values.passwordConfirmation) {
      if (values.password !== values.passwordConfirmation) {
        errors.passwordConfirmation = 'Senhas não conferem!'
      }
    } else {
      errors.passwordConfirmation = 'Confirme a senha!'
    }
  } else {
    errors.password = 'Forneça uma senha!'
  }

  return errors
}
